import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full pt-4 pb-16 px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center relative" data-id="element-159">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="max-w-5xl mx-auto flex flex-col items-center" data-id="element-160">
        <div className="text-brand-cyan font-bold tracking-widest text-[10px] sm:text-xs mb-4 uppercase flex items-center gap-2" data-id="element-161">
          <span className="text-base" style={{
          fontFamily: 'serif'
        }} data-id="element-162">
            ∞
          </span>
          Infinitamente digital
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-163">
            <path d="M12 2a5 5 0 0 1 4.9 4 4.5 4.5 0 0 1 2.1 3.8 4.5 4.5 0 0 1-1.5 3.4A4 4 0 0 1 16 17h-1v5h-6v-5H8a4 4 0 0 1-1.5-3.8A4.5 4.5 0 0 1 5 9.8 4.5 4.5 0 0 1 7.1 6 5 5 0 0 1 12 2z" data-id="element-164" />
            <path d="M12 2v8" data-id="element-165" />
            <path d="M8 10h8" data-id="element-166" />
          </svg>
        </div>

        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-white leading-tight mb-6 tracking-tight max-w-4xl" data-id="element-167">
          Blindá tus cuentas <span className="text-brand-cyan" data-id="element-168">AHORA</span>
        </h1>

        <div className="relative w-full max-w-2xl mx-auto mb-2" data-id="element-169">
          <img src="https://cdn.magicpatterns.com/uploads/fuFWKn3Lcjzibc9UnddKCS/a12e262c-163f-4be8-aca0-27ef5e775406.png" alt="Mega Pack Cuenta Blindada" className="w-full h-auto object-contain drop-shadow-2xl pl-[10px] pr-[10px] mt-[-70px] mb-[-70px] ml-[0px] mr-[0px]" data-id="element-170" />
          <motion.div initial={{
          scale: 0,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          delay: 0.4,
          duration: 0.4,
          type: 'spring',
          stiffness: 200
        }} className="absolute bottom-16 -right-2 sm:bottom-20 sm:-right-4 rounded-full flex flex-col items-center justify-center z-10" style={{
          background: 'radial-gradient(circle at 30% 30%, #67e8f9, #00D4FF 40%, #0891b2 100%)',
          boxShadow: '0 0 15px rgba(0,212,255,0.4), 0 0 30px rgba(0,212,255,0.15), inset 0 1px 1px rgba(255,255,255,0.3)',
          border: '1.5px solid rgba(103,232,249,0.5)',
          width: '4rem',
          height: '4rem'
        }} data-id="element-171">
            <span className="text-black font-extrabold text-sm sm:text-base leading-none drop-shadow-sm" data-id="element-172">
              +6
            </span>
            <span className="text-black/80 font-bold text-[7px] sm:text-[8px] leading-tight text-center uppercase tracking-wider" data-id="element-173">
              Bonos
              <br data-id="element-174" />
              Exclusivos
            </span>
          </motion.div>
        </div>

        <p className="text-lg sm:text-xl md:text-2xl text-white font-medium mb-6 -mt-14 max-w-3xl leading-relaxed" data-id="element-175">
          Protegé tu{' '}
          <span className="text-brand-cyan font-extrabold" data-id="element-176">WhatsApp</span>, tu{' '}
          <span className="text-brand-cyan font-extrabold" data-id="element-177">Home Banking</span> y
          tus{' '}
          <span className="text-brand-cyan font-extrabold" data-id="element-178">
            billeteras virtuales
          </span>{' '}
          antes de que alguien más lo haga por vos.
        </p>

        <motion.a href="#pricing" initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3,
        duration: 0.5
      }} className="mb-8 inline-flex items-center gap-2 bg-green-500 text-white font-extrabold text-lg sm:text-xl px-10 py-4 rounded-full shadow-[0_0_25px_rgba(34,197,94,0.4)] hover:shadow-[0_0_35px_rgba(34,197,94,0.6)] hover:bg-green-600 hover:scale-105 transition-all duration-200 uppercase tracking-wide" data-id="element-179">
          Quiero blindar mis cuentas
        </motion.a>

        <div className="flex flex-wrap justify-center gap-2 sm:gap-3 text-[10px] sm:text-xs text-gray-400 font-normal" data-id="element-180">
          <div className="border border-brand-cyan/15 rounded-full px-3 py-1 flex items-center gap-1.5" data-id="element-181">
            <span className="text-[10px]" data-id="element-182">📄</span> 100% PDF
          </div>
          <div className="border border-brand-cyan/15 rounded-full px-3 py-1 flex items-center gap-1.5" data-id="element-183">
            <span className="text-[10px]" data-id="element-184">⚡</span> Acceso inmediato
          </div>
          <div className="border border-brand-cyan/15 rounded-full px-3 py-1 flex items-center gap-1.5" data-id="element-185">
            <span className="text-[10px]" data-id="element-186">🛡️</span> Garantía 7 días
          </div>
          <div className="border border-brand-cyan/15 rounded-full px-3 py-1 flex items-center gap-1.5" data-id="element-187">
            <span className="text-[10px]" data-id="element-188">💳</span> Mercado Pago
          </div>
        </div>
      </motion.div>
    </section>;
}